import { useRef, forwardRef, useImperativeHandle } from "react";

interface OTPInputProps {
    otp: string[];
    setOtp: React.Dispatch<React.SetStateAction<string[]>>;
    className: string;
}

export interface OTPInputRef {
    focus: () => void;
}

const OTPInput = forwardRef<OTPInputRef, OTPInputProps>(({ otp, setOtp, className }, ref) => {
    const inputRef = useRef<HTMLInputElement[]>(Array(6).fill(null));

    useImperativeHandle(ref, () => ({
        focus: () => {
            inputRef.current[0]?.focus();
        }
    }));

    const handleChangeOtp = (value: string, idx: number) => {
        if (!(+value >= 0 && +value <= 9)) return null;

        const newValue = [...otp];
        newValue[idx] = value;
        setOtp(newValue);

        if (value.length === 1 && idx < 5) {
            inputRef.current[idx + 1]?.focus();
        }

        if (value.length === 0 && idx > 0) {
            inputRef.current[idx - 1]?.focus();
        }
    };

    const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData("Text").split("");

        if (!pastedData.every((el) => +el >= 0 && +el <= 9)) return null;

        const newOtp = [...otp];
        pastedData.forEach((char, i) => {
            if (i < 6) {
                newOtp[i] = char;
            }
        });
        setOtp(newOtp);
    };

    return (
        <div className={`${className} flex`}>
            {Array.from({ length: 6 }, (_, idx) => (
                <input
                    key={idx}
                    autoFocus={idx === 0 && otp.every((el) => el.length === 0)}
                    type="text"
                    maxLength={1}
                    value={otp[idx]}
                    onChange={(e) => handleChangeOtp(e.target.value, idx)}
                    onPaste={handlePaste}
                    ref={(ref) =>
                        (inputRef.current[idx] = ref as HTMLInputElement)
                    }
                    className="w-12 h-12 bg-blue-light text-center font-semibold outline-none focus:border-blue-light"
                />
            ))}
        </div>
    );
});

OTPInput.displayName = "OTPInput";

export default OTPInput;
